/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// library
// https://tvkhoa.github.io/testlib/
// https://github.com/tvkhoa/react-tippy#props
// also uses a stylesheet we import in app.js
// check app_styles for more '.tippy-tooltip'
import { Tooltip } from 'react-tippy';



/* ========== ~~~~~~~~~~ TOOLTIP : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class ToolTip extends Component {
	constructor(props) {
		super(props);
		this.state = { open: this.props.delay ? this.handleDelay() : this.props.open };
	}
	handleDelay = () => {
		this.setState({ open: false });
		setTimeout(() => {
			this.setState({ open: true });
		}, this.props.delay)
	};
	render() {
	    return(
	        <Tooltip 
	        	html={this.props.content}
	  			position={this.props.position}
	  			trigger={this.props.trigger}
	  			open={this.state.open}
	  			distance={15}
	  			followCursor={false}
	  			arrow={true}
	  			arrowSize={'big'}
	  			size={'regular'}
	  			multiple={true}
	  			sticky={true}
	  			stickyDuration={100}
	  			interactive={true}
	  			animation={'perspective'}
	  			duration={100}>{this.props.children}</Tooltip>
	    );
	}
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default ToolTip;
